import { useState } from 'react';

import { useGetAccuracyPromptBodyQuery } from '../../api/accuracyApiSlice';

interface UseExtractionPromptSectionArgs {
  projectId: string | null;
  promptPath: string | null;
  /** ai-prompts branch to preview at; undefined lets the backend default to `main`. */
  branch?: string;
}

export const useExtractionPromptSection = ({
  projectId,
  promptPath,
  branch,
}: UseExtractionPromptSectionArgs) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { data, isFetching, error } = useGetAccuracyPromptBodyQuery(
    { projectId: projectId ?? '', promptPath: promptPath ?? '', branch },
    { skip: !isDialogOpen || !projectId || !promptPath }
  );

  return {
    isDialogOpen,
    openDialog: () => setIsDialogOpen(true),
    closeDialog: () => setIsDialogOpen(false),
    promptBody: data?.data ?? null,
    isPromptBodyLoading: isFetching,
    promptBodyError: error,
  };
};
